import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/close_x_blue.svg'
import _imports_1 from '@/assets/img/arrow_left_brand.svg'
import _imports_2 from '@/assets/img/arrow_right_brand.svg'
import _imports_3 from '@/assets/img/face_love_blue_with_violet_eyes.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-6822f1e9")

_pushScopeId("data-v-6822f1e9")
const _hoisted_1 = { class: "modal full bg_white" }
const _hoisted_2 = { class: "modal_header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_5 = { class: "d-flex justify-content-center mb-4" }
const _hoisted_6 = { class: "swiper-slide" }
const _hoisted_7 = {
  key: 0,
  class: "modal_footer flex_align_centered column"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  class: "mb-1",
  src: _imports_3
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_header_feven = _resolveComponent("header-feven")
  const _component_person_info = _resolveComponent("person-info")
  const _component_chevron_fixed = _resolveComponent("chevron-fixed")
  const _component_love_face_shadow_bar = _resolveComponent("love-face-shadow-bar")
  const _component_image_and_questions_view_other_profile = _resolveComponent("image-and-questions-view-other-profile")
  const _component_swiper_slides = _resolveComponent("swiper-slides")
  const _component_localized_text = _resolveComponent("localized-text")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_header_feven, { white: false }, {
        right: _withId(() => [
          _createVNode("img", {
            src: _imports_0,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
          })
        ]),
        _: 1
      })
    ]),
    _createVNode("div", {
      class: ["modal_body p-0", !_ctx.replyStatusNotCompleted ? 'reply_completed' : '']
    }, [
      _createVNode(_component_person_info, {
        name: _ctx.match.personName,
        birthDate: _ctx.match.birthDate,
        distanceMeters: _ctx.match.distanceMeters,
        sexualOrientation: _ctx.match.sexualOrientation
      }, null, 8, ["name", "birthDate", "distanceMeters", "sexualOrientation"]),
      _createVNode("div", null, [
        (_ctx.match.questions.length > 0 && _ctx.localIndex > 0)
          ? (_openBlock(), _createBlock(_component_chevron_fixed, {
              key: 0,
              vertical: "top",
              horizontal: "left",
              class: "blueLeftBg",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.localIndex--))
            }, {
              default: _withId(() => [
                _hoisted_3
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.match.questions.length > 0 && _ctx.localIndex < _ctx.match.questions.length - 1)
          ? (_openBlock(), _createBlock(_component_chevron_fixed, {
              key: 1,
              vertical: "top",
              horizontal: "right",
              class: "blueRightBg",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.localIndex++))
            }, {
              default: _withId(() => [
                _hoisted_4
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_love_face_shadow_bar, {
            class: "d-flex align-items-center mt-2",
            text: _ctx.affinityRateText
          }, null, 8, ["text"])
        ]),
        _createVNode(_component_swiper_slides, {
          itemsLenght: _ctx.match.questions.length,
          autoHeight: false,
          slidesPerView: 1,
          slideIndex: _ctx.localIndex,
          onSlidechange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.localIndex = $event))
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.match.questions, (item, index) => {
              return (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode(_component_image_and_questions_view_other_profile, { profileQuestion: item }, null, 8, ["profileQuestion"])
              ]))
            }), 256))
          ]),
          _: 1
        }, 8, ["itemsLenght", "slideIndex"])
      ])
    ], 2),
    (_ctx.replyStatusNotCompleted)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_localized_text, {
            class: "fw_600 fev_text6 mb-3",
            localizedKey: "app_LeTueRisposteNonInfluirannoSulRisultatoDelMatch",
            text: "Le tue risposte non influiranno sul risultato del match"
          }),
          _createVNode("button", {
            class: "fev_button bg_brand",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.replyCallback()))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "app_RispondiAlleDomande",
              text: "Rispondi alle domande"
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})